<template>
  <div class="container">
    <div class="text-container">
      <p>We've added AI</p>
      <img class="image" src="@/assets/sparkels.png" width="20" height="20" alt="">
      <p>Generate a job description using ChatGPT</p>
    </div>
  </div>

</template>

<script>
export default{
  name: 'ai-banner'
}
</script>

<style scoped lang="scss">
@import "~@/styles/defaults.scss";
.container{
  padding: 10px;
  background: linear-gradient(90deg, rgba(76, 26, 87, 0.66) 0%, rgba(255, 60, 199, 0.66) 100%), #4C1A57;
  //margin-bottom: 20px;
  margin: 0;
}
.text-container{
  display: flex;
  justify-content: center;
  width: 100%;
  color: #FFF;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.image{
  width: 24px;
  margin-left: 8px;
  margin-right: 8px;
}

@media screen and (max-width: $tablet) {
  .container{
    padding: 10px;
    background: linear-gradient(90deg, rgba(76, 26, 87, 0.66) 0%, rgba(255, 60, 199, 0.66) 100%), #4C1A57;
    margin-bottom: 20px;
  }
  .text-container{
    display: flex;
    justify-content: center;
    width: 100%;
    color: #FFF;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .image{
    width: 8px;
    margin-left: 8px;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/al-banner.vue